import { FC } from 'react';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';

type Props = {
  note: IncidentDetailPatient['note'];
};

export const NotesView: FC<Props> = ({ note }) => (
  <BorderedContainer>
    <div className="flex flex-col gap-[24px]">
      <SectionTitle text="備考" />
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay title="備考" content={note} />
      </div>
    </div>
  </BorderedContainer>
);
